import Helper from 'src/helpers';
import { messages } from 'src/constants/messages';

export const MessageStatusError = (status) => {
  /**
   * Status trả về (action.status) ---
   * 400: Trùng
   * 401: Hết phiên làm việc
   * 404: Dịch vụ không tồn tại
   * 417: Dữ liệu không tồn tại
   * 500: Lỗi dữ liệu
   * 504: Gateway Time-out
   */
  switch (status) {
    case 400:
      Helper.alertError(messages.TRUNG_DU_LIEU);
      break;
    case 401:
      Helper.alertError(messages.HET_PHIEN_LAM_VIEC);
      break;
    case 404:
      Helper.alertError(messages.DICH_VU_KO_TON_TAI);
      break;
    case 405:
      Helper.alertError(messages.DICH_VU_KO_TON_TAI);
      break;
    case 409:
      Helper.alertError(messages.NOI_DUNG_TRUNG_LAP);
      break;
    case 415:
      Helper.alertError(messages.PHUONG_THUC_KHONG_DUOC_HO_TRO);
      break;
    case 416:
      Helper.alertError(messages.DU_LIEU_DANG_SU_DUNG);
      break;
    case 417:
      Helper.alertError(messages.DU_LIEU_KO_TON_TAI);
      break;
    case 500:
      Helper.alertError(messages.LOI_HE_THONG);
      break;
    case 503:
      Helper.alertError(messages.QUA_TAI);
      break;
    case 504:
      Helper.alertError(messages.KHONG_PHAN_HOI);
      break;
    default:
      break;
  }
};

export const MessageStatusSuccess = (apiType) => {
  /**
   * Thông báo (action.apiType) ---
   * LIST: Fetch danh sách
   * ADD: Thêm mới
   * EDIT: Sửa
   * DELETE: Xoá
   * DETAIL: Chi tiết
   */
  switch (apiType) {
    case 'ADD':
      Helper.alertSuccessMessage(messages.THEM_THANH_CONG);
      break;
    case 'DELETE':
      Helper.alertSuccessMessage(messages.XOA_THANH_CONG);
      break;
    case 'EDIT':
      Helper.alertSuccessMessage(messages.CAP_NHAT_THANH_CONG);
      break;
    case 'SEND':
      Helper.alertSuccessMessage(messages.GUI_THANH_CONG);
      break;
    case 'APPROVED':
      Helper.alertSuccessMessage(messages.DUYET_THANH_CONG);
      break;
    default:
      break;
  }
};
